/**
 * Capitalizes the first word, and transform others to lower case
 */
export const capitalizeOnlyFirstWord = (str: string) => {
  if (typeof str !== 'string') {
    console.error('"capitalizeOnlyFirst()" accepts only strings!');
    return '';
  }
  return str.replaceAll(/[A-Z]/g, (x) => x.toLowerCase()).replace(/^([a-z])/, (x) => x.toUpperCase());
};

/**
 * Capitalizes the first word and the rest are untouched
 */
export const capitalize = (str: string) => {
  if (typeof str !== 'string') {
    console.error('"capitalize()" accepts only strings!');
    return '';
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Capitalizes every word in string
 */
export const toTitleCase = (str: string) => {
  if (typeof str !== 'string') {
    console.error('"toTitleCase()" accepts only strings!');
    return '';
  }
  return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());
};
